"use client";

import { forwardRef } from "react";
import { TextSearchIcon, XIcon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface AtcSearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  className?: string;
}

export const AtcSearchBar = forwardRef<HTMLInputElement, AtcSearchBarProps>(
  ({ value, onChange, onClear, className }, ref) => (
    <div className={cn("relative", className)}>
      <Input
        ref={ref}
        value={value}
        onChange={onChange}
        placeholder="Filtruj po nazwie leku"
        className="h-10 pr-9 pl-3"
      />
      <TextSearchIcon className="absolute top-1/2 right-3 size-4 -translate-y-1/2 text-gray-400" />
      {value && (
        <button
          onClick={onClear}
          className="absolute top-1/2 right-3 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          aria-label="Wyczyść wyszukiwanie"
        >
          <XIcon className="size-4" />
        </button>
      )}
    </div>
  ),
);

AtcSearchBar.displayName = "AtcSearchBar";
